import axios from 'axios';
import { handleError } from '@/_helpers/utils';

export default {
  namespaced: true,

  state() {
    return {
      data: null,
      loading: false, // используется для запроса на получение статуса прохождения
      loaded: false,
      error: null
    };
  },

  actions: {
    load(context) {
      context.commit('set_loaded', false);
      context.commit('set_error', null);
      return axios
        .post(`/1.0/interviews/${context.getters.token}/talentq`)
        .then(response => response.data)
        .then(data => {
          context.commit('set_data', data);
          context.commit('set_loaded', true);
        })
        .catch(err => {
          err = handleError(err);
          context.commit('set_error', err);
          throw err;
        });
    },

    finish(context) {
      context.commit('set_loading', true);
      context.commit('set_error', null);
      return axios
        .post(`/1.0/interviews/${context.getters.token}/talentq`)
        .then(response => response.data)
        .then(data => {
          context.commit('set_data', data);
          context.commit('set_loading', false);
        })
        .catch(err => {
          err = handleError(err);
          context.commit('set_error', err);
          context.commit('set_loading', false);
          throw err;
        });
    }
  },

  mutations: {
    set_data(state, data) {
      state.data = data;
    },
    set_loading(state, loading) {
      state.loading = loading;
    },
    set_loaded(state, loaded) {
      state.loaded = loaded;
    },
    set_error(state, error) {
      state.error = error;
    }
  },

  getters: {
    data: state => state.data || {},
    loading: state => state.loading,
    loaded: state => state.loaded,
    error: state => state.error,
    token: (state, getters, rootState) => rootState.route.params.token,
    company_logo: (state, getters) => getters.data.company && getters.data.company.logo,
    process: state => (state.data.meta ? state.data.meta.active_process : null),
    get_assessment_by_code_id: (state, getters) => id =>
      getters.data.assessments &&
      getters.data.assessments.find(assessment => assessment.code.id === id)
  }
};
